import { trpc } from '@/utils/trpc'

// Infer types from the tRPC mutation
type MutationFn = typeof trpc.createPaymentIntent.useMutation
type Options = Parameters<MutationFn>[0]

export const useCreatePaymentIntent = (options: Options = {}) => {
  const {
    mutate: createPaymentIntent,
    mutateAsync: createPaymentIntentAsync,
    isPending,
  } = trpc.createPaymentIntent.useMutation(options)
  return {
    createPaymentIntent,
    createPaymentIntentAsync,
    isPending,
  }
}
